import { type PropsOverrides, type PropsWithOverrides } from './models';

export function mapStyleDataToProps(styleData: Record<string, unknown>[]): PropsWithOverrides {
  const [props, tablet, mobile] = styleData;
  const result: PropsWithOverrides = { props };

  if (!tablet && !mobile) {
    return result;
  }

  result.overrides = {};
  if (tablet) {
    result.overrides.tablet = { props: tablet };
  }
  if (mobile) {
    result.overrides.mobile = { props: mobile };
  }

  return result;
}

export function mapPropsToStyleData(
  props: Record<string, unknown>,
  overrides?: PropsOverrides,
): any[] {
  const result: any[] = [props];
  if (overrides?.tablet?.props) {
    result.push(overrides.tablet.props);
  }
  if (overrides?.mobile?.props) {
    result.push(overrides?.mobile?.props);
  }
  return result;
}
